module.exports = __webpack_public_path__ + "static/img/5-5.afed2814.png";